module.exports = __webpack_public_path__ + "img/swords-crossed.a9065b2e.svg";